import React from "react";
import { Box, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  selectNavDenominatorMode,
  selectPositionCalculationMode,
  setNavDenominatorMode,
  setPositionCalculationMode,
} from "../Redux/Reducers/uiSlice";
import {
  NAV_DENOMINATOR_MODE_OPTIONS,
  POSITION_CALCULATION_MODE_OPTIONS,
} from "../utils/positionCalculationMode";

const toggleButtonSx = {
  textTransform: "none",
  fontWeight: 500,
  px: 1.5,
  py: 0.75,
  fontSize: "0.8125rem",
};

const PositionsCalculationToggle = ({ sx }) => {
  const dispatch = useDispatch();
  const mode = useSelector(selectPositionCalculationMode);
  const navDenominatorMode = useSelector(selectNavDenominatorMode);

  const handleChange = (_event, nextMode) => {
    if (nextMode) {
      dispatch(setPositionCalculationMode(nextMode));
    }
  };

  const handleNavDenominatorChange = (_event, nextMode) => {
    if (nextMode) {
      dispatch(setNavDenominatorMode(nextMode));
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        flexWrap: "wrap",
        ...sx,
      }}
    >
      <ToggleButtonGroup
        color="primary"
        value={mode}
        exclusive
        onChange={handleChange}
        aria-label="Position calculation mode"
        size="small"
        sx={{
          flexWrap: "wrap",
          "& .MuiToggleButton-root": toggleButtonSx,
        }}
      >
        {POSITION_CALCULATION_MODE_OPTIONS.map(({ value, label }) => (
          <ToggleButton key={value} value={value} aria-label={label}>
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>

      <ToggleButtonGroup
        color="primary"
        value={navDenominatorMode}
        exclusive
        onChange={handleNavDenominatorChange}
        aria-label="Capital mode"
        size="small"
        sx={{
          flexWrap: "wrap",
          "& .MuiToggleButton-root": toggleButtonSx,
        }}
      >
        {NAV_DENOMINATOR_MODE_OPTIONS.map(({ value, label }) => (
          <ToggleButton key={value} value={value} aria-label={label}>
            {label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default PositionsCalculationToggle;
